/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetaAttribute } from '../../models/meta-attribute';

export interface LoadMetaAttributesWithValue$Params {
  orid: number;
  meid: number;
}

export function loadMetaAttributesWithValue(http: HttpClient, rootUrl: string, params: LoadMetaAttributesWithValue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MetaAttribute>>> {
  const rb = new RequestBuilder(rootUrl, loadMetaAttributesWithValue.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('meid', params.meid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MetaAttribute>>;
    })
  );
}

loadMetaAttributesWithValue.PATH = '/api/Organizations/loadMetaAttributesWithValue/{orid}/{meid}';
